import { MODULE_NAME } from "../moduleName";
import { GlobalState } from "./state";

// a reducer from another module
export const authSelector = (state: GlobalState) => state.auth.user;

export const linkedRecordsSelector = (state: GlobalState) => {
  try {
    return state[MODULE_NAME].linkedRecords;
  } catch (e) {
    throw new Error(
      `Check you have included @ofqual/portal-linked-records in your coreItems prop for Shell. Error: ${e}`
    );
  }
};
